// import React, { useState, useCallback, useEffect } from "react";
// import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
// import { useSelector, useDispatch } from "react-redux";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../../Action";
// import "./RerouteModalStyles.css";
// import { deleteQuestionOpen } from "../../../API/api";
// import { toast } from "react-toastify";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function DeleteExpertRecordModal() {
//     const [isLoading, isLoaded] = useState(false);
//     const successMsg = (message) => {
//         return (
//             <>
//                 <span style={{ fontSize: "12px" }}>{message}</span>
//             </>
//         );
//     };
//     const modalState = useSelector((state) => state.domain);
//     const expertRecordsState = useSelector((state) => state.expertRecord);
//     const dispatch = useDispatch();
//     const currentPath = useLocation();
//     const navigate = useNavigate();
//     const { advanceFilterModalToggle, cmrRefreshPage, cmrClickedData, cmrIsGoBack } = bindActionCreators(Actions, dispatch);
//     const onClickButtons = () => {
//         if (currentPath.pathname.includes('/expertrecordDetail/')) {
//             isLoaded(true);
//             deleteQuestionOpen(expertRecordsState.clickedData.questionUuid).then(res => {
//                 if (res===undefined) return;
//                 cmrIsGoBack(false)
//                 advanceFilterModalToggle({ bool: false, value: "" });
//                 // navigate('/cmHome/expertRecords/')
//                 navigate('/cmHome/expertResponses')
//                 if (res.success) {
//                     toast.success(successMsg(res.message), {
//                         position: toast.POSITION.TOP_RIGHT
//                     })
//                 }
//             })
//         }
//         // if (currentPath.pathname.includes('/expertRecords/')) {
//         if (currentPath.pathname.includes('/expertResponses')) {
//             isLoaded(true);
//             deleteQuestionOpen(expertRecordsState.clickedData.map(obj => obj.questionUuid).toString()).then(res => {
//                 if (res===undefined) return;
//                 cmrRefreshPage(1);
//                 cmrClickedData(null)
//                 advanceFilterModalToggle({ bool: false, value: "" })
//                 if (res.success) {
//                     toast.success(successMsg(res.message), {
//                         position: toast.POSITION.TOP_RIGHT
//                     })
//                 }
//             })
//         }
//     }
//     return (
//         <Modal show={modalState.modalState}
//             onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//             centered={true}
//             size={"lg"}
//             style={{ marginTop: "-50px" }}
//         // scrollable={true}
//         >
//             <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
//                 <ModalTitle>
//                     <h5 className="headingModal"><i className="fa fa-trash" style={{ paddingRight: "7px", fontSize: "16px" }}></i>Are you sure you want to Delete this Question?</h5>
//                 </ModalTitle>
//             </ModalHeader>
//             <ModalBody>
//                 <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
//                     <div className="container">
//                         <p style={{ color: 'grey', fontSize: '16px', fontWeight: '100' }}>All of the answers tied to this question will also be deleted.</p>
//                         <p style={{ color: 'grey', fontSize: '16px', fontWeight: '100' }}>And the Seeker will no longer be able to view this question.</p>

//                         {!isLoading && <div>
//                             <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button className="rerouteBtn" onClick={() => onClickButtons()}>Yes</button>
//                         </div>}
//                         {isLoading &&
//                             <div>
//                                 <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting</button>
//                             </div>}
//                     </div>
//                 </div>
//             </ModalBody>
//         </Modal>
//     )
// }


import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./RerouteModalStyles.css";
import { deleteQuestionOpen } from "../../../API/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from './deleteStyle.module.css'

const modalTitleStyle = {
    color: "rgb(42, 54, 74)",
    fontSize: "20px",
    fontFamily: "Helvetica",
  };

const textStyles1 = {
   fontSize: "16px",
   color: "#2A364A",
   lineHeight: "24px",
   fontWeight: "500",
   wordBreak: 'break-word', overflowWrap: 'break-word',
   textAlign: "left",
   display:"flex",
   justifyContent:"center",
   width:"100%"


};
export default function DeleteExpertRecordModal() {
   const [isLoading, isLoaded] = useState(false);
   const successMsg = (message) => {
       return (
           <>
               <span style={{ fontSize: "12px" }}>{message}</span>
           </>
       );
   };
   const modalState = useSelector((state) => state.domain);
   const expertRecordsState = useSelector((state) => state.expertRecord);
   const dispatch = useDispatch();
   const currentPath = useLocation();
   const navigate = useNavigate();
   const { advanceFilterModalToggle, cmrRefreshPage, cmrClickedData, cmrIsGoBack } = bindActionCreators(Actions, dispatch);
   const onClickButtons = () => {
       if (currentPath.pathname.includes('/expertrecordDetail/')) {
           isLoaded(true);
           deleteQuestionOpen(expertRecordsState.clickedData.questionUuid).then(res => {
               if (res === undefined) return;
               cmrIsGoBack(false)
               advanceFilterModalToggle({ bool: false, value: "" });
               // navigate('/cmHome/expertRecords/')
               navigate('/cmHome/expertResponses')
               if (res.success) {
                   toast.success(successMsg(res.message), {
                       position: toast.POSITION.TOP_RIGHT
                   })
               }
           })
       }
       // if (currentPath.pathname.includes('/expertRecords/')) {
       if (currentPath.pathname.includes('/expertResponses')) {
           isLoaded(true);
           deleteQuestionOpen(expertRecordsState.clickedData.map(obj => obj.questionUuid).toString()).then(res => {
               if (res === undefined) return;
               cmrRefreshPage(1);
               cmrClickedData(null)
               advanceFilterModalToggle({ bool: false, value: "" })
               if (res.success) {
                   toast.success(successMsg(res.message), {
                       position: toast.POSITION.TOP_RIGHT
                   })
               }
           })
       }
   }
   return (
       <Modal show={modalState.modalState}
           onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
           centered={true}
           size={"lg"}
           style={{ marginTop: "-50px" }}
       // scrollable={true}
       >
           {/* <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
               <ModalTitle>
                   <h5 className="headingModal"><i className="fa fa-trash" style={{ paddingRight: "7px", fontSize: "16px" }}></i>Are you sure you want to Delete this Question?</h5>
               </ModalTitle>
           </ModalHeader> */}


           <Modal.Header closeButton>
               <Modal.Title style={modalTitleStyle}>
                     <span>
                     <i class="fa fa-trash" aria-hidden="true"> </i> &nbsp;&nbsp;Are you sure you want to Delete this Question?
                     </span>
                 
               </Modal.Title>
           </Modal.Header>
           <ModalBody>
               <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                   <div className="container">
                       <div style={{width:"100%",justifyContent:"center"}}>
                       <p style={textStyles1}>All of the answers tied to this question will also be deleted.</p>
                       <p style={textStyles1}>And the Seeker will no longer be able to view this question.</p>
                       </div>
                   


                       {!isLoading && <div>
                           <button style={{
                               padding: '8px 12px 8px 12px',
                               borderRadius: '6px',
                               fontSize: '14px',
                               lineHeight: '24px',
                               fontWeight: 400,
                               boxShadow: ' 0px 1px 2px 0px #1018280D',
                               color: '#2A364A',
                               border: '1px solid  #fff',
                               height: '40px',
                               minWidth: '88px',
                               background: " #F6F7F8",
                               marginBottom: '14px',
                               fontWeight: 400,
                               border: " 1px solid #E0E2E6"


                               //  font-weight: 400;          
                           }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No
                           </button>&nbsp;<button
                          style={{
                           padding: '8px 12px 8px 12px',
                           borderRadius: '6px',
                           fontSize: '14px',
                           lineHeight: '24px',
                           fontWeight: 400,
                           boxShadow: '0px 1px 2px 0px #1018280D',
                           color: '#FFFFFF',
                           border: '1px solid  #fff',
                           height: '40px',
                           minWidth: '88px',
                           background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                           marginBottom: '14px',
                           cursor: "pointer"
                         }}
                            onClick={() => onClickButtons()}>Yes</button>
                       </div>}
                       {isLoading &&
                           <div>
                               <button
                               style={{
                                   padding: '8px 12px 8px 12px',
                                   borderRadius: '6px',
                                   fontSize: '14px',
                                   lineHeight: '24px',
                                   fontWeight: 400,
                                   boxShadow: '0px 1px 2px 0px #1018280D',
                                   color: '#FFFFFF',
                                   border: '1px solid  #fff',
                                   height: '40px',
                                   minWidth: '88px',
                                   background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                   marginBottom: '14px',
                                   cursor: "not-allowed",
                                   opacity:"0.7"
                                 }}
                              disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting</button>
                           </div>}
                   </div>
               </div>
           </ModalBody>
       </Modal>
   )
}
